import React from 'react';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { AppRootWrapperBlueprint } from '@backstage/plugin-app-react';
import { PanelWidget } from './PanelWidget';

const PanelWrapper = AppRootWrapperBlueprint.make({
  params: {
    component: ({ children }) => (
      <>
        {children}
        <PanelWidget />
      </>
    ),
  },
});

export const panelModule = createFrontendModule({
  pluginId: 'app',
  extensions: [PanelWrapper],
});
